import { useLocation } from "react-router"
import bhumeet from "../../../assets/bhumeet.svg"
import { useEffect, useState } from "react"
import Loading from "../../../ReusableFunctions/Loader"
import Popup from "../../../ReusableFunctions/Popup"
import dateFormat from 'dateformat';
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import dashLine from "../../../assets/dashLine.svg"
import { formatToIndianRupees, squareKilometersToAcres } from "../../../ReusableFunctions/reusableFunctions"
import { DSP_INVOICES_TYPES } from "../../../appConstants"
import { getDspSettlementSubInvoiceDetails } from "../../../apis/adminAPIs/finance/dspInvoices"

const SubscriptionInvoiceDetails = () => {
    const { dsp, invoice } = useLocation().state
    const [settInvoice, setSettInvoice] = useState({})
    const [isDownload, setIsDownload] = useState(false)

    const getSettelementInvoiceDetailsFunc = async () => {
        try {
            Loading.set(true)
            const settleInvoice = await getDspSettlementSubInvoiceDetails(invoice?.id);
            console.log("settleInvoice", settleInvoice);
            setSettInvoice({
                ...settleInvoice,
                time: new Date(settleInvoice?.time),
                invoice_id: invoice?.id,
                generated_time: new Date(settleInvoice?.generated_time),
                to_bank_account_name: settleInvoice?.dsp_bank_account?.bank_name,
                to_bank_account_ifsc: settleInvoice?.dsp_bank_account?.ifsc_code,
                to_bank_account_number: settleInvoice?.dsp_bank_account?.account_no,
                to_bank_account_holder_name: settleInvoice?.dsp_bank_account?.account_holder_name,
            });
            Loading.set(false)
        } catch (error) {
            Loading.set(false)
            Popup.alert("Error", error, "ERROR")
        }
    }

    const wait = async () => {
        return new Promise((resolve) => {
            setTimeout(resolve, 0)
        })
    }


    const downloadPDF = async () => {
        setIsDownload(true);
        Loading.set(true)
        await wait(); // Assuming wait() is some delay or other asynchronous task
        const input = document.querySelector('.myDiv');

        html2canvas(input, {
            scale: 1.5,
            useCORS: true,
            backgroundColor: null,
        }).then(canvas => {
            const imgWidth = 210; // A4 width in mm
            const pageHeight = 297; // A4 height in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width; // Proportional image height
            let heightLeft = imgHeight;

            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4',
                compress: true,
            });

            let position = 0; // Position on the first page
            let pageCount = 1;
            pdf.setFontSize(10);

            // Add the first image
            const imgData = canvas.toDataURL('image/png', 0.8); // 80% quality

            pdf.addImage(
                imgData,
                'PNG',
                0,
                position,
                imgWidth,
                imgHeight
            );
            heightLeft -= pageHeight; // Subtract page height from image height
            pdf.text(`Page ${pageCount}`, 100, 290);

            // Add new pages if there's more content
            while (heightLeft > 0) {
                position = heightLeft - imgHeight; // Update position for next page
                pdf.addPage(); // Add new page
                pdf.addImage(
                    imgData,
                    'PNG',
                    0,
                    position,
                    imgWidth,
                    imgHeight
                );
                pageCount++
                pdf.text(`Page ${pageCount}`, 100, 290);
                heightLeft -= pageHeight; // Subtract again for the next page
            }

            pdf.save('invoice.pdf');
            setIsDownload(false);
            Loading.set(false);
        });
    };

    useEffect(() => {
        getSettelementInvoiceDetailsFunc()
    }, [])

    let gst_amount = settInvoice.total_amount * 0.18;
    let amount_with_tax = Number(settInvoice.total_amount) + Number(gst_amount);
    let locations_limits = settInvoice.plan_limits?.find((lmt) => lmt.name === 'locations')?.limit;
    let leads_limits = settInvoice.plan_limits?.find((lmt) => lmt.name === 'leads')?.limit;
    let drones_limits = settInvoice.plan_limits?.find((lmt) => lmt.name === 'drones')?.limit;
    
    // if (locations_limits == -1) {
    //     locations_limits = 'Unlimited'
    // }
    // if (drones_limits == -1) {
    //     drones_limits = 'Unlimited'
    // }
    // if (leads_limits == -1) {
    //     leads_limits = 'Unlimited'
    // }
    return (
        <div style={{ overflow: "auto", position: "relative", display: "flex", flexDirection: "column", alignItems: "center", gap: '20px' }}>
            {isDownload ? (
                <div style={{
                    position: 'relative',
                    top: '10px',
                    right: '-240px',
                    fontSize: '14px',
                }}>
                    Downloading...
                </div>
            ) : (
                <a
                    onClick={downloadPDF}
                    style={{
                        position: 'relative',
                        top: '10px',
                        right: '-240px',
                        textDecoration: 'underline',
                        color: '#007BFF',
                        cursor: 'pointer',
                        fontSize: '14px',
                    }}
                >
                    Download Invoice
                </a>
            )}
            <div className='myDiv' style={{ width: "620px" }}>
                <div style={{
                    width: '620px',
                    border: isDownload ? 'none' : '1px solid rgba(215, 218, 224, 0.4)',
                    borderRadius: '5px',
                    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                    color: "#3B3B3B",
                    backgroundColor: '#fff',
                    paddingTop: isDownload ? "5px" : "0px"
                }}>
                    <div>
                        <div className="text-center" style={{fontWeight: 700, marginTop: "20px", fontSize: "24px"}}>
                            <h1>Tax Invoice</h1>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            margin: '0px 30px',
                            padding: '10px 0px',
                            borderBottom: '1px solid rgba(215, 218, 224, 0.3)',
                        }}>
                            <div>
                                <img src={bhumeet} alt="bhumeet" width={"120px"} />
                            </div>
                            <div style={{ textAlign: 'right' }} className="text-[13px] text-gray-500">
                                <p style={{ margin: '0', }}><span>Invoice No.</span> - {settInvoice?.invoice_number || "-"}</p>
                                <p style={{ margin: '0', }}><span>Invoice Date - </span><span >{dateFormat(settInvoice?.generated_time, "dd mmm yyyy")}</span></p>
                            </div>
                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            color: "#727272",
                            padding: "20px 30px"
                        }}>
                            <div className="flex flex-col gap-4">
                                {/* From Section */}
                                <div>
                                    <p style={{ margin: '0', fontWeight: 500 }}>From</p>
                                    <p style={{ margin: '0', fontWeight: 'bold', color: "#1E1E1E" }}>
                                        {settInvoice?.from?.name || "-"}
                                    </p>
                                    <p style={{ margin: '0' }}>
                                        {settInvoice?.from?.address
                                            ? settInvoice.from.address
                                            : settInvoice?.from?.city || "-"}
                                    </p>
                                    <p style={{ margin: '0' }}>
                                        {settInvoice?.from?.gstin || "-"}
                                    </p>
                                </div>

                                {/* To Section */}
                                <div style={{ marginBottom: '20px' }}>
                                    <p style={{ margin: '0', fontWeight: 500 }}>To</p>
                                    <p style={{ margin: '0', fontWeight: 'bold', color: "#1E1E1E" }}>
                                        {settInvoice?.to?.name || "-"}
                                    </p>
                                    <p style={{ margin: '0' }}>
                                        {settInvoice?.to?.address
                                            ? settInvoice.to.address
                                            : settInvoice?.to?.city || "-"}
                                    </p>
                                    {settInvoice?.dsp_gstin && (
                                        <p style={{ margin: '0' }}>GSTIN - {settInvoice?.dsp_gstin}</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        
                        <div style={{
                            backgroundColor: '#D9D9D9',
                            padding: '10px 25px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            fontWeight: 700,
                            color: '#1E1E1E',
                            height: "50px",
                            alignItems: "center",
                            fontSize: "18px",
                        }}>
                            <span className="w-[55%]">Subscription Plan & Description</span>
                            <span className="w-[10%] flex justify-center">Qty</span>
                            <span className="w-[25%] flex justify-end">Rates</span>
                        </div>

                        <div style={{ padding: '10px 30px 10px', width: "100%" }}>
                            {settInvoice?.total_amount > 0 && <div style={{ marginBottom: '6px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 500 }}>
                                    <div className="flex flex-col w-[55%] ">
                                        <div className="flex flex-col gap-[1px]">
                                            <div className="flex gap-2 items-center">
                                                <span>{settInvoice?.name}</span>
                                            </div>
                                            {/* <div className="text-[12px] flex  text-gray-500">
                                                (
                                                {drones_limits && <span>{`Drones:${drones_limits}`}</span>}
                                                {locations_limits && <span className="ml-2">{`Locations:${locations_limits}`}</span>}
                                                {leads_limits && <span className="ml-2">{`Leads:${leads_limits}`}</span>}
                                                )
                                            </div> */}
                                        </div>
                                    </div>
                                    <span className="w-[10%] flex justify-center">1</span>
                                    <span className="w-[25%] flex justify-end">₹ {formatToIndianRupees(settInvoice?.total_amount || 0)}</span>
                                </div>
                            </div>}

                            <div style={{ marginBottom: '10px', fontWeight: 500 }}>
                                        <div className="flex flex-col gap-[4px] text-[12px] text-gray-500">
                                            <div className="flex gap-2 items-center">
                                                <span>What you will get :</span>
                                            </div>
                                            <div className="">
                                                <p><span className="mr-[2px]">{drones_limits == -1 ? `Unlimited Drones Subscription` : drones_limits == 1 ? `${drones_limits} Drone Subscription Included` : `${drones_limits} Drones Subscription Included`}</span></p>
                                                <p><span className="mr-[2px]">{locations_limits == -1 ? `Unlimited Locations` : locations_limits == 1 ? `${locations_limits} Location Included` : `${locations_limits} Locations Included`} </span></p>
                                                <p><span className="mr-[2px]">{leads_limits == -1 ? `Unlimited Leads` : leads_limits == 1 ? `${leads_limits} Lead Included` : `${leads_limits} Leads Included`}</span></p>
                                                <p><span className="mr-[2px]">Access Order Management</span></p>
                                            </div>
                                        </div>
                            </div>

                            <div style={{ marginBottom: '10px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 500 }}>
                                    <div className="flex flex-col w-[58%] ">
                                        <div className="flex flex-col gap-[4px]">
                                            <div className="flex gap-2 items-center">
                                                <span>Service Period</span>
                                                <span className="text-sm text-gray-500">
                                                    ({settInvoice?.plan_type && settInvoice.plan_type.charAt(0).toUpperCase() + settInvoice.plan_type.slice(1)})
                                                </span>
                                            </div>
                                            <div className="flex gap-[2px] items-center text-[12px] text-gray-500">
                                                (
                                                <p><span className="mr-[2px]">From</span>{dateFormat(settInvoice?.sub_start_date, "dd/mm/yyyy")}</p>
                                                <p><span className="ml-[2px] mr-[2px]">To</span>{dateFormat(settInvoice?.sub_end_date, "dd/mm/yyyy")}</p>
                                                )
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {settInvoice?.total_amount && <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginTop: '10px',
                                padding: "10px 0px",
                                borderTop: "1px solid rgba(215, 218, 224, 0.6)",
                                fontWeight: 500
                            }}>
                                <div className="flex flex-col gap-[1px]" >
                                    <span>SubTotal</span>
                                </div>
                                <span>₹ {formatToIndianRupees(settInvoice?.total_amount || 0)}</span>
                            </div>}

                            <img src={dashLine} alt="dashLine" style={{ maxWidth: "103%" }} />
                            {gst_amount && <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginTop: '10px',
                                fontWeight: 500
                            }}>
                                <div className="flex gap-[5px] items-center" >
                                    <span>GST</span>
                                    <span className="text-[12px] text-gray-500">(18%)</span>
                                </div>
                                <span>+ ₹ {formatToIndianRupees(gst_amount || 0)}</span>
                            </div>}

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                paddingTop: '15px',
                                marginTop: '10px',
                                marginBottom: '30px',
                                fontWeight: 'bold',
                                borderTop: '1px solid rgba(215, 218, 224, 0.6)',
                                paddingBottom: '10px',
                                fontSize: "18px",
                                marginBottom: (isDownload && settInvoice.invoice_type === DSP_INVOICES_TYPES.DEBIT_FOR_BHUMEET && (!settInvoice?.incentive_from_bhumeet_amount || settInvoice?.incentive_from_bhumeet_amount <= 0)) ? "80px" : isDownload && settInvoice.invoice_type === DSP_INVOICES_TYPES.DEBIT_FOR_DSP ? "120px" : ""
                            }}>
                                <span>Total Amount</span>
                                <span>₹ {formatToIndianRupees(amount_with_tax || 0)}</span>
                            </div>

                            <div style={{
                                paddingTop: '10px',
                                marginTop: isDownload ? '90px' : '10px',
                                marginBottom: '30px',
                                paddingBottom: '10px',
                            }}>
                                <h2 style={{marginBottom: "5px", paddingBottom: "10px", color: "rgb(0,0,0)", fontSize: "12px", fontWeight: 700}}>Terms & Conditions</h2>
                                <div style={{color: "rgb(30,30,30)", fontWeight: 600, fontSize: "12px"}}>
                                    <p>1. Drone Service Providers (DSPs) must subscribe to the BhuMeet Base SaaS Plan to access BhuMeet services and features.</p>
                                    <p>2. Plan features, pricing, and inclusions are listed under Product Pricing – BhuMeet on the BhuMeet platform.</p>
                                    <p>3. 100% advance payment is required for activation of the selected subscription plan.</p>
                                    <p>4. Subscription fees are non-refundable, except where required by applicable .</p>
                                    <p>5. Service access will remain active only while subscription payments are up to date.</p>
                                    <p>6. Any additional value-added services (e.g., leads) are billed separately as per service usage.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div >
        </div>
    )
}

export default SubscriptionInvoiceDetails